export default "__VITE_ASSET__DUk3YQO2__"